import { computed, Injectable, Signal, signal, WritableSignal } from '@angular/core';

import { SearchResultsAggregationBucket } from 'remarketing-angular-library';
import { SaService } from 'smartauction-frontend-micro-library';

@Injectable({ providedIn: 'root' })
export class DealerFilterService extends SaService {

  private dealerList$: WritableSignal<SearchResultsAggregationBucket[]> = signal([]);
  private searchTerm$: WritableSignal<string> = signal('');

  private computedDealerList$: Signal<SearchResultsAggregationBucket[]> = computed(() => {
    const currentSearchTerm = this.searchTerm$();
    const dealerList = this.dealerList$();

    if (currentSearchTerm === '' || dealerList.length === 0) {
      return dealerList;
    }

    return dealerList.filter(d => d.name.toLocaleLowerCase().includes(currentSearchTerm));
  });

  setDealerList(dealerList: SearchResultsAggregationBucket[]) {
    this.dealerList$.set(dealerList);
  }

  setSearchTerm(searchTerm: string) {
    this.searchTerm$.set(searchTerm);
  }

  getSearchTerm() {
    return this.searchTerm$();
  }

  getComputedDealerList() {
    return this.computedDealerList$();
  }

  getComputedDealerList$() {
    return this.computedDealerList$;
  }

}
